module.exports = __webpack_public_path__ + "static/media/su_map_ack_3.b942f15e.jpeg";